export function setGlobalWaitCursor(enable: boolean): void {
  if (typeof document === 'undefined' || !document.body) return;

  document.body.style.cursor = enable ? 'wait' : '';
}
